import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import MenuContext from './MenuContext';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import Api from './Api';

const getWidgetContent = (widget) => {
  if (!widget.length) {
    return false;
  }
  return widget.map((w) => w);
};

const getData = (item) => {
  const items = {
    logo: [],
    language: [],
    text: [],
  };
  if (item.widgets.length) {
    item.widgets.forEach((itm, i) => {
      if (i === 0) {
        items.logo = getWidgetContent(itm.widget_contents);
      }
      if (i === 1) {
        items.language = getWidgetContent(itm.widget_contents);
      }
      if (i === 2) {
        items.text = getWidgetContent(itm.widget_contents);
      }
      if (i === 3) {
        items.link = getWidgetContent(itm.widget_contents);
      }
    });
  }
  return items;
};

const api = new Api();

export default function SSoft_Header_Non_Global() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  // const [isInitialize, setIsInitialize] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sections, setSections] = useState("");
  const [menu, setMenu] = useState("");
  const [data, setData] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const getMenuDetail = useCallback((params) => {
    return new Promise((resolve, reject) => {
      api
        .getMenuDetail(params)
        .then((res) => {
          if (res.status === 200 && res.data) {
            resolve(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }, []);

  const getSectionDetail = useCallback((index) => {
    return new Promise((resolve, reject) => {
      api
        .getSectionDetail(index)
        .then((res) => {
          if (res.status === 200 && res.data.results.length) {
            resolve(res.data.results[0]);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }, []);

  const getDefaultData = useCallback(async () => {
    const [a, b] = await Promise.all([
      getMenuDetail({ language: activeLanguage }),
      getSectionDetail({ language: activeLanguage }),
    ]);
    if (a && b) {
      const newData = getData(b);
      setData(newData);
      const filteredMenu = a.items.filter(
        (itm) => itm.id !== 575 && itm.id !== 636
      );

      setMenu(filteredMenu);
      setSections(b);
      setIsLoaded(true);
    }
  }, [getMenuDetail, getSectionDetail, activeLanguage]);

  useLayoutEffect(() => {
    getDefaultData();
    return () => {};
  }, [getDefaultData]);

  let html = <div />;
  if (sections && menu) {
    html = (
      <>
        <DesktopMenu isLoaded={isLoaded} data={sections} menu={menu} />
        <MobileMenu isLoaded={isLoaded} data={sections} menu={menu} />
      </>
    );
  }

  const context = useMemo(
    () => ({ isDesktop, isSearch, setIsSearch, sections, menu, data }),
    [isDesktop, isSearch, sections, menu, data]
  );

  return <MenuContext.Provider value={context}>{html}</MenuContext.Provider>;
}

// .section-container {
//   @apply max-w-[88%] hd:max-w-[90%] xl:max-w-[1200px] hdl:max-w-[1440px] mx-auto;
// }
